import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Login() {
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { login, senha });
      localStorage.setItem('ht_token', data.token);
      localStorage.setItem('ht_usuario', JSON.stringify({ login, tipo: data.tipo, onboardingId: data.onboardingId }));
      nav(data.tipo === 'admin' ? '/admin' : `/onboarding/${data.onboardingId}`);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao autenticar. Verifique suas credenciais.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-900 via-brand-700 to-brand-500 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img src="/logo_ht.png" alt="HeadThink" className="h-16 w-auto mx-auto mb-4 drop-shadow-lg" />
          <h1 className="text-white text-2xl font-bold tracking-tight">Portal de Onboarding</h1>
          <p className="text-blue-200 text-sm mt-1">HeadThink Soluções</p>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">Entrar</h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label">Login</label>
              <input
                type="text"
                value={login}
                onChange={e => setLogin(e.target.value)}
                className="input"
                placeholder="Seu login de acesso"
                autoFocus
                required
              />
            </div>
            <div>
              <label className="label">Senha</label>
              <input
                type="password"
                value={senha}
                onChange={e => setSenha(e.target.value)}
                className="input"
                placeholder="Sua senha"
                required
              />
            </div>

            {erro && (
              <div className="px-4 py-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-sm text-red-700">{erro}</p>
              </div>
            )}

            <button type="submit" disabled={loading} className="btn-primary w-full justify-center py-3 text-base">
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
        </div>

        <p className="text-center text-blue-200 text-xs mt-6">
          © {new Date().getFullYear()} HeadThink Soluções. Todos os direitos reservados.
        </p>
      </div>
    </div>
  );
}
